import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "../lib/api";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/reviews?limit=100").then((r) => { setReviews(r.data); setLoading(false); });
  }, []);
  return (
    <div className="container-wide py-16" data-testid="page-reviews">
      <div className="border-b hairline pb-8 mb-10">
        <div className="overline text-[#7A1519] mb-3">Reviews</div>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter text-[#111111] font-semibold">In our customers' words</h1>
      </div>
      {loading ? <div className="text-sm">Loading…</div> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <div key={r.id} className="bg-white border hairline p-8 rounded-sm" data-testid={`review-${r.id}`}>
              <div className="flex gap-1 text-[#7A1519]">
                {Array.from({ length: r.rating }).map((_, i) => <Star key={i} size={14} fill="currentColor" />)}
              </div>
              <p className="mt-5 text-sm text-[#242424] leading-relaxed">"{r.text}"</p>
              <div className="mt-6 pt-4 border-t hairline">
                <div className="font-display font-semibold text-[#111111]">{r.customer_name}</div>
                {r.vehicle_purchased && <div className="text-xs text-[#242424]/60 mt-0.5">{r.vehicle_purchased}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Reviews;
